import { IParamsGetJobs, IPayloadAddJob, IPayloadUpdateJob, IResponseGetBoardCount, IResponseGetJobs, IJobUploadFile, IParamsGetJobPhotos } from '~/utils/interface/job';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { urlApiJobs } from '~/utils/constants/apis';

export interface ITradeType {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  createdBy: string;
  updatedBy: string;
  deletedBy: string | null;
  name: string;
}

export interface IResponseGetTradeTypes {
  responses: Array<ITradeType>;
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

const jobApi = {
  getJobs(params: IParamsGetJobs) {
    return axiosClient.get<IApiBaseResponse<IResponseGetJobs>>(`${urlApiJobs.getJobs}`, { params });
  },

  getBoardCount() {
    return axiosClient.get<IResponseGetBoardCount>(urlApiJobs.getBoardCount);
  },
  moveStage(id: string, params: IParamsGetJobs) {
    return axiosClient.put<IApiBaseResponse<any>>(`/api/jobs/${id}/move`, undefined, { params });
  },

  addJob(data: IPayloadAddJob) {
    return axiosClient.post<IApiBaseResponse<any>>(`${urlApiJobs.addJob}`, data);
  },

  deleteJob(id: string) {
    return axiosClient.delete<IApiBaseResponse<any>>(`/api/jobs/${id}`);
  },

  getTradeTypes() {
    return axiosClient.get<IApiBaseResponse<IResponseGetTradeTypes>>('/api/trade-types', {
      params: { page: 1, limit: 100 },
    });
  },

  getJobDetails(id: string) {
    return axiosClient.get(`/api/jobs/${id}`);
  },

  updateJob(id: string, data: IPayloadUpdateJob) {
    return axiosClient.put<IApiBaseResponse<any>>(`/api/jobs/${id}`, data);
  },

  getPhotos(id:string, params: IParamsGetJobPhotos){
    return axiosClient.get<IApiBaseResponse<any>>(`/api/jobs/${id}/images`, {params});
  },

  getPhotoDetail(idJob:string, idPhoto:string){
    return axiosClient.get<IApiBaseResponse<any>>(`/api/jobs/${idJob}/images/${idPhoto}`);
  },

  uploadPhotos(id:string, data:IJobUploadFile){
    return axiosClient.post<IApiBaseResponse<any>>(`/api/jobs/${id}/images`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  updatePhoto(idJob:string, idPhoto:string, data:IJobUploadFile){
    return axiosClient.put<IApiBaseResponse<any>>(`/api/jobs/${idJob}/images/${idPhoto}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  

  deletePhoto(idJob:string, idPhoto:string){
    return axiosClient.delete<IApiBaseResponse<any>>(`/api/jobs/${idJob}/images/${idPhoto}`);
  },


  //estiamte 
  addEstimate(data:any) {
    return axiosClient.post<IApiBaseResponse<any>>(`/api/estimates`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  getAllEstimate(params:any) {
    return axiosClient.get<IApiBaseResponse<any>>(`/api/estimates`,{params});
  },
  handleGetAllEstimateDetail(id:string) {
    return axiosClient.get<IApiBaseResponse<any>>(`/api/estimates/${id}`);
  },
  updateEstimate(id:string, data:any){
    return axiosClient.put<IApiBaseResponse<any>>(`/api/estimates/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  handleDeleteEstimate(id:string){
    return axiosClient.delete<IApiBaseResponse<any>>(`/api/estimates/${id}`);
  }
};

export default jobApi;
